import { render, staticRenderFns } from "./GamesTable.vue?vue&type=template&id=19d91360&"
import script from "./GamesTable.vue?vue&type=script&lang=js&"
export * from "./GamesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports